import React from 'react';

export default class Toast extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      level: 'info',
      duration: 2000,
      status: false
    };
    this.toast = React.createRef();
  }

  show(content, level = 'info', duration = 2000) {
    return new Promise(resolve => {
      if (duration) {
        window.setTimeout(() => {
          this.hide().then(resolve);
        }, duration);
      } else {
        this.toast.current.addEventListener('transitionend', resolve, { once: true });
      }
      this.setState({
        content,
        level,
        duration,
        status: true
      });
    });
  }

  hide() {
    return new Promise(resolve => {
      this.toast.current.addEventListener('transitionend', resolve, { once: true });
      this.setState({ status: false });
    });
  }

  render() {
    return (
      <div className={"toast fade w-auto text-white bg-" + this.state.level + (this.state.status ? ' show' : '')} ref={this.toast}>
        <div className="toast-body text-center">{this.state.content}</div>
      </div>
    );
  }

}
